import React from "react";
import {useSelector} from "react-redux";
import {useStyles} from "./styles";
import {Box, Typography, Divider} from "@material-ui/core";
import DockerManagement from "../../../components/Administration/DockerManagement";
import DockerManagementProvider from "../../../components/Administration/DockerManagement/DockerManagementProvider";

const DockerManagementPage = () => {
  const classes = useStyles();
  const isAdmin = useSelector(state => state?.user?.isAdmin);

  if (!isAdmin) return <></>;

  return (
    <div className={classes.root}>
      {/* <Typography className={classes.title} variant="h4">Docker Management</Typography>
      <Divider className={classes.titleDivider}/> */}
      <Box display="flex" justifyContent="center" alignItems="center">
        <DockerManagementProvider>
					<DockerManagement />
        </DockerManagementProvider>
      </Box>
    </div>
  );
};

export default DockerManagementPage;
